import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Gallery = () => {
  const { language } = useLanguage();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/gallery`).then(res => setImages(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white font-body" data-testid="gallery-page">
      <Navbar />

      <PageHero
        kicker={language === 'en' ? 'A look inside' : 'अंदर एक नज़र'}
        title={language === 'en' ? 'Gallery' : 'गैलरी'}
        subtitle={language === 'en' ? 'A glimpse into our hospital facilities and environment' : 'हमारी अस्पताल सुविधाओं और वातावरण की एक झलक'}
        testId="gallery-hero"
      />

      <div className="py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6">
          {loading ? (
            <div className="text-center text-neutral-400">Loading...</div>
          ) : images.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-grid">
              {images.map((image, index) => (
                <div key={image.id} className="group relative overflow-hidden cursor-pointer" data-testid={`gallery-image-${index}`}>
                  <img src={image.image_url} alt={language === 'en' ? image.title_en : image.title_hi}
                    className="w-full h-80 object-cover grayscale-[0.15] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  {(image.title_en || image.title_hi) && (
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <p className="text-white text-xs uppercase tracking-ultra-wide font-body">
                        {language === 'en' ? image.title_en : image.title_hi}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-neutral-400 font-body">
              {language === 'en' ? 'No images available' : 'कोई छवि उपलब्ध नहीं'}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Gallery;
